import React, { useEffect, useState } from 'react';
import styles from './CustomSlider.module.scss';
import { FormLabel, Grid } from '@mui/material';
import { Box } from '@mui/system';
import { makeStyles } from '@mui/styles';
// import Slider from '@material-ui/core/Slider';
import Slider from '@mui/material/Slider';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import CustomTextField from '../customTextField/CustomTextField';
import { numberWithCommas } from '../../../utils/numberWithCommas';
import { extractOnlyNumFromString } from '../../../utils/extractOnlyNumFromString';

const CustomSlider = (props) => {
	const {
		formLabel,
		defaultMin,
		defaultMax,
		rangeMin,
		rangeMax,
		name,
		params,
		setParams,
		suffix,
		prefix,
		customLabel,
		marks,
	} = props;
	const [value, setValue] = useState([defaultMin, defaultMax]);

	const useStyles = makeStyles((theme) => ({
		inputLabel: {
			color: 'var(--text-mid-emphasis)',
			fontSize: 'var(--text-size-small)',
			marginBottom: '10px',
			marginLeft: '5px',
		},
	}));
	console.log('Check defaultMin', value);
	const handleChange = (event, newValue) => {
		console.log('handle Change new', event, name);
		setValue(newValue);
		setParams({
			...params,
			[name]: newValue,
		});
	};

	const classes = useStyles();

	const ClaySlider = createTheme({
		overrides: {
			color: 'var(--text-mid-emphasis)',
			height: 1,
			track: {
				border: 'none',
			},
			thumb: {
				height: 24,
				width: 24,
				backgroundColor: '#fff',
				border: '2px solid var(--primary)',
				'&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
					boxShadow: 'inherit',
				},
				'&:before': {
					display: 'none',
				},
			},
		},
	});

	const handleChangeMin = (e) => {
		console.log('CHECK', e.target.value);
		let val =
			Number(e.target.value) || extractOnlyNumFromString(e.target.value);
		let newArr = [...value];
		if (val < rangeMax) {
			newArr[0] = val;
			setValue(newArr);
			setParams({
				...params,
				[name]: newArr,
			});
		} else {
			newArr[0] = rangeMin;
			setValue(newArr);
			setParams({
				...params,
				[name]: newArr,
			});
		}
	};
	const handleChangeMax = (e) => {
		// e.target.value ===customLabel?.max? 0
		let val =
			Number(e.target.value) || extractOnlyNumFromString(e.target.value);
		console.log('CHECK 2', e.target.value, val);
		let newArr = [...value];
		if (val <= rangeMax) {
			console.log('CHECK 2-1', rangeMax);
			newArr[1] = val;
			setValue(newArr);
			setParams({
				...params,
				[name]: newArr,
			});
		} else {
			console.log('CHECK 2-2', rangeMax);
			newArr[1] = rangeMax;
			setValue(newArr);
			setParams({
				...params,
				[name]: newArr,
			});
		}
	};
	const valueLabelFormat = (value) => {
		if (customLabel?.max && value === rangeMax) {
			return customLabel?.max;
		} else if (prefix) {
			return prefix + numberWithCommas(value);
		} else if (suffix) {
			return numberWithCommas(value) + suffix;
		} else {
			return value;
		}
	};
	const handleDeleteKey = (e) => {};
	return (
		<div className={styles.slider_wrapper}>
			<Box>
				<FormLabel className={classes.inputLabel}>
					{formLabel}
				</FormLabel>
				<ThemeProvider theme={ClaySlider}>
					<Box px={2}>
						<Slider
							value={value}
							onChange={handleChange}
							valueLabelDisplay='auto'
							valueLabelFormat={valueLabelFormat}
							min={rangeMin}
							max={rangeMax}
							name={name}
							marks={marks ? marks : false}
						/>
					</Box>
				</ThemeProvider>

				{customLabel ? (
					<Grid container spacing={1}>
						<Grid item xs={6}>
							<div
								className={
									prefix
										? styles.prefixWrapper
										: styles.suffixWrapper
								}
							>
								<CustomTextField
									value={numberWithCommas(value[0])}
									onChange={handleChangeMin}
								/>
								{prefix && (
									<span className={styles.prefix}>
										{prefix}
									</span>
								)}
								{suffix && (
									<span className={styles.suffix}>
										{suffix}
									</span>
								)}
							</div>
						</Grid>
						<Grid item xs={6}>
							<div
								className={
									prefix
										? styles.prefixWrapper
										: styles.suffixWrapper
								}
								onKeyDown={handleDeleteKey}
							>
								<CustomTextField
									value={
										customLabel?.max &&
										value[1] === rangeMax
											? customLabel?.max
											: numberWithCommas(value[1])
									}
									onChange={handleChangeMax}
								/>
								{prefix && (
									<span className={styles.prefix}>
										{prefix}
									</span>
								)}
								{suffix && (
									<span className={styles.suffix}>
										{suffix}
									</span>
								)}
							</div>
						</Grid>
					</Grid>
				) : (
					<div className={styles.inputBoxes}>
						<CustomTextField
							width={'100%'}
							padding={'5px'}
							value={value[0]}
							onChange={handleChangeMin}
							type={'number'}
						/>
						<CustomTextField
							width={'100%'}
							padding={'5px'}
							value={value[1]}
							onChange={handleChangeMax}
							type={'number'}
						/>
					</div>
				)}
			</Box>
		</div>
	);
};

export default CustomSlider;
